import { useEffect, useState } from 'react';

type MouseStates = {
  mousePress: boolean;
  mouseEnter: boolean;
};

export function useMouseClickStates<T extends HTMLElement>(): [
  (node: T | null) => void,
  MouseStates,
] {
  const [ref, setRef] = useState<T | null>(null);
  const [mousePress, setMousePress] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);

  useEffect(() => {
    const handlePointerUp = () => {
      setMousePress(false);
    };
    const handlePointerDown = () => {
      setMousePress(true);
    };
    const handlePointerEnter = () => {
      setMouseEnter(true);
    };
    const handlePointerLeave = () => {
      setMouseEnter(false);
    };

    window.addEventListener('pointerup', handlePointerUp, true);
    ref?.addEventListener('pointerdown', handlePointerDown, true);
    ref?.addEventListener('pointerup', handlePointerUp, true);
    ref?.addEventListener('pointerenter', handlePointerEnter, true);
    ref?.addEventListener('pointerleave', handlePointerLeave, true);

    return () => {
      window.removeEventListener('pointerup', handlePointerUp, true);
      ref?.removeEventListener('pointerdown', handlePointerDown, true);
      ref?.removeEventListener('pointerup', handlePointerUp, true);
      ref?.removeEventListener('pointerenter', handlePointerEnter, true);
      ref?.removeEventListener('pointerleave', handlePointerLeave, true);
    };
  }, [ref]);

  return [setRef, { mousePress, mouseEnter }];
}
